import request from './request.js'

//  获取登录验证码
export function getLoginCode(params = {}) {
  return request({
    url: '/captchaImage',
    method: 'GET',
    params
  })
}


//   获取手机验证码（注册用）
export function getSmsCode(params) {
  return request({
    url: '/system/user/sendSmsCode',
    method: 'POST',
    data: params
  })
}

//  用户登录
export function login(data) {
  return request({
    url: '/login',
    method: 'POST',
    data
  })
}

// 注册用户
export function register(data) {
  return request({
    url: '/system/user/register',
    method: 'POST',
    data
  })
}

//  获取个人信息
export function getUserInfo(config = {}) {
  return request({
    url: '/system/user/info',
    method: 'GET',
    ...config
  })
}


//  修改密码
export function updatePassword(data) {
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'PUT',
    data
  })
}

/**
 * 上传文件
 * @param {FormData} formData - 文件表单数据
 * @param {Object} config - axios配置（可以包含上传进度等）
 * @returns {Promise}
 */
export function uploadFile(formData, config = {}) {
  return request({
    url: '/common/upload',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config
  })
}

// 退出登录（需要token）
export function logout() {
  return request({
    url: '/logout',
    method: 'GET'
  })
}

// 弃土/找土管理
// 新增
export function addSoilInfo(data) {
  return request({
    url: '/soil/info',
    method: 'POST',
    data
  })
}

// 列表
export function getSoilInfoList(data) {
  return request({
    url: '/soil/info/webList',
    method: 'GET',
    params: data
  })
}

// 我的发布列表
export function getMySoilInfoList(data) {
  return request({
    url: '/soil/info/my/list',
    method: 'GET',
    params: data
  })
}

// 更新土方信息
export function updateSoilInfo(data) {
  return request({
    url: '/soil/info/my/update',
    method: 'POST',
    data
  })
}

// 上架/下架土方信息
export function updateSoilInfoStatus(data) {
  return request({
    url: '/soil/info/my/updateStatus',
    method: 'POST',
    data
  })
}

// 删除土方信息
export function removeSoilInfo(id) {
  return request({
    url: `/soil/info/my/remove/${id}`,
    method: 'POST'
  })
}

// 获取通知列表
export function getNoticeList(params) {
  return request({
    url: '/system/notice/myList',
    method: 'GET',
    params
  })
}

// 获取未读通知数量
export function getUnreadCount() {
  return request({
    url: '/system/notice/myUnreadCount',
    method: 'GET'
  })
}

// 获取通知详情
export function getNoticeDetail(noticeId) {
  return request({
    url: `/system/notice/myDetail/${noticeId}`,
    method: 'GET'
  })
}

// 详情
export function getWebInfoDetail(id) {
    return request({
      url: `/soil/info/webInfo/${encodeURIComponent(id)}`,
      method: 'GET'
    })
  }


// 咨询、法规、规范管理
// 列表查询
/**
 * 获取咨询、法规、规范列表
 * @param {Object} params - 查询参数
 * @param {string} params.type - 类型：0水保咨询, 1法律法规, 2技术规范 (必需)
 * @param {string} params.pageNum - 页码 (必需)
 * @param {string} params.pageSize - 每页数量 (必需)
 * @param {string} params.source - 来源 (可选)
 * @param {string} params.year - 年份 (可选)
 * @param {string} params.keyword - 关键词查询 (可选)
 * @returns {Promise}
 */
export function getConsultInfoList(params) {
  return request({
    url: '/consult/info/webList',
    method: 'GET',
    params
  })
}

// 详情查询
export function getConsultInfoDetail(id) {
  return request({
    url: `/consult/info/webInfo/${encodeURIComponent(id)}`,
    method: 'GET'
  })
}

// 查询来源
export function getConsultSource(params = {}) {
  return request({
    url: '/consult/info/sourceList',
    method: 'GET',
    params
  })
}

//新增土方匹配申请
export function addSoilApply(data) {
  return request({
    url: '/soil/apply',
    method: 'POST',
    data
  })
}

// 处理匹配申请
export function processSoilApply(data) {
  return request({
    url: '/soil/apply/process',
    method: 'POST',
    data
  })
}

//查询我的申请列表
export function getMySoilApplyList(data) {
  return request({
    url: '/soil/apply/myApply',
    method: 'GET',
    params: data
  })
}

//查询待我处理的申请列表
export function getMySoilApplyListPending(data) {
  return request({
    url: '/soil/apply/pending',
    method: 'GET',
    params: data
  })
}

// 本人未匹配土方列表
export function getMySoilInfoSmartUnmatched(data) {
  return request({
    url: '/soil/info/smartUnmatched',
    method: 'GET',
    params: data
  })
}

// 成功案例列表
export function getWebSuccessCaseList(data) {
  return request({
    url: '/soil/apply/web/list',
    method: 'GET',
    params: data
  })
}

// 成功案例详情
export function getWebSuccessCaseDetail(id) {
  return request({
    url: `/soil/apply/${encodeURIComponent(id)}`,
    method: 'GET'
  })
}

//下载见证书文件
export function downloadWitnessFile(applyId) {
  return request({
    url: `/soil/apply/downloadWitness/${applyId}`,
    method: 'GET',
    responseType: 'blob' // 设置响应类型为 blob，用于文件下载
  })
}